import {
  Block,
  BlockProps,
  Breadcrumbs,
  LabelSmall,
  ParagraphSmall,
  useStyletron,
} from "@mezo-org/mezo-clay"
import { Link } from "@tanstack/react-router"

import { selectWalletBalances, useDappSelector } from "#/redux-state"
import { routes } from "#/shared/constants"
import { bigIntToCommaSeparatedFloat } from "#/shared/utils"

import { TokenIcon } from "../Token"

export default function MarketBalanceHeader({
  pageTitle,
  overrides,
}: {
  pageTitle?: string
  overrides?: BlockProps["overrides"]
}) {
  const { MUSD } = useDappSelector(selectWalletBalances)

  const [css, theme] = useStyletron()

  return (
    <Block
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent={pageTitle ? "space-between" : "flex-end"}
      paddingRight={theme.sizing.scale600}
      paddingLeft={theme.sizing.scale600}
      marginBottom={theme.sizing.scale600}
      className={css({ gap: "50px" })}
      overrides={overrides}
    >
      {pageTitle && (
        <Breadcrumbs>
          <Link to={routes.MARKET}>Market</Link>
          <span>{pageTitle}</span>
        </Breadcrumbs>
      )}
      <Block
        display="flex"
        flexDirection="column"
        alignItems="flex-end"
        marginBottom="auto"
      >
        <ParagraphSmall
          color={theme.colors.contentTertiary}
          marginBottom={theme.sizing.scale100}
        >
          Available&nbsp;balance
        </ParagraphSmall>
        <LabelSmall
          className={css({
            display: "flex",
            alignItems: "center",
            gap: theme.sizing.scale100,
          })}
        >
          <TokenIcon token="MUSD" />
          {bigIntToCommaSeparatedFloat(
            MUSD.balance,
            Number(MUSD.decimals),
            Number(MUSD.decimals),
          )}{" "}
          MUSD
        </LabelSmall>
      </Block>
    </Block>
  )
}
